const LONG_PRESS_MS = 450;
const MOVE_TOLERANCE_PX = 10;

/**
 * Su touch, tenere premuta un'icona con `title` (dentro containerSelector)
 * rivela il testo del title in una bolla, senza eseguire l'azione al rilascio.
 * Un tap rapido resta invariato: l'azione parte subito, come oggi.
 */
export function initLongPressLabels(containerSelector, root = document) {
  let timer = null;
  let startX = 0;
  let startY = 0;
  let bubbleEl = null;
  let revealed = false;

  const cancelTimer = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const removeBubble = () => {
    bubbleEl?.remove();
    bubbleEl = null;
  };

  const resetState = () => {
    cancelTimer();
    removeBubble();
    revealed = false;
  };

  const showLabel = (el) => {
    const text = el.getAttribute('title') || el.getAttribute('aria-label');
    if (!text) return;
    bubbleEl = document.createElement('div');
    bubbleEl.className = 'long-press-label';
    bubbleEl.textContent = text;
    document.body.appendChild(bubbleEl);
    const rect = el.getBoundingClientRect();
    bubbleEl.style.left = `${rect.left + rect.width / 2}px`;
    bubbleEl.style.top = `${rect.top}px`;
    revealed = true;
  };

  root.addEventListener('touchstart', (e) => {
    const el = e.target.closest?.(`${containerSelector} [title]`);
    if (!el) return;
    revealed = false;
    removeBubble();
    const t = e.touches[0];
    startX = t.clientX;
    startY = t.clientY;
    cancelTimer();
    timer = setTimeout(() => showLabel(el), LONG_PRESS_MS);
  }, { passive: true });

  root.addEventListener('touchmove', (e) => {
    if (!timer) return;
    const t = e.touches[0];
    if (Math.abs(t.clientX - startX) > MOVE_TOLERANCE_PX || Math.abs(t.clientY - startY) > MOVE_TOLERANCE_PX) {
      cancelTimer();
    }
  }, { passive: true });

  root.addEventListener('touchend', (e) => {
    cancelTimer();
    if (revealed) {
      e.preventDefault();
      removeBubble();
      revealed = false;
    }
  });

  root.addEventListener('touchcancel', (e) => {
    resetState();
  });
}
